import React, { useEffect, useMemo, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import Table from "../../../core/common/dataTable/index";
import EmployeeReviewDetailsSection from "./employeeReviewDetailsSection";
import CommonSelect from "../../../core/common/commonSelect";

const statusChoose = [
  { value: "1", label: "Active" },
  { value: "0", label: "Inactive" },
];
type Option = {
  value: string;
  label: string;
};

const EmployeeBehaviouralReview = () => {
  const [loading, setLoading] = useState(false);
  const [allItemList, setAllItemList] = useState<any[]>([]);
  const [newItem, setNewItem] = useState<any>({
    band: "",
    category: "",
    smart_goal: "",
    target: "",
    target_date: "",
  });
  const [selectedItem, setSelectedItem] = useState<any>({});
  const [showReviewDetail, setShowReviewDetail] = useState<boolean>(false);
  const [errors, setErrors] = useState<any>({});
  const [employeeList, setEmployeeList] = useState<any[]>([]);

  const formatFinancialYear = (year: number) => {
    const nextYearShort = (year + 1).toString().slice(-2);
    return `${year}-${nextYearShort}`;
  };

  const getCurrentFinancialYear = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth();
    const fyStart = month >= 3 ? year : year - 1;
    return formatFinancialYear(fyStart);
  };
  const [finance_year, setFinance_year] = useState(getCurrentFinancialYear());

  const options_employee: any[] = useMemo(
    () =>
      employeeList.map((item) => ({
        value: `${item.employee_id}`,
        label: `${item.employee_id} -  ${item.employee_name}`,
      })),
    [employeeList]
  );

  const columns = [
    {
      title: "Sr No.",
      dataIndex: "SrNo",
      render: (text: string, record: any, index: number) => (
        <h6 className="fw-medium fs-14 text-dark" style={{ width: "50px" }}>
          {index + 1}
        </h6>
      ),
      // sorter: (a: any, b: any) => a.SrNo - b.SrNo,
    },
    {
      title: "Employee",
      dataIndex: "employee",
      render: (text: string) => <p style={{ width: "150px" }}>{text}</p>,
      sorter: (a: any, b: any) => a.employee.localeCompare(b.employee),
    },
    {
      title: "Behavioural Competency",
      dataIndex: "competencyName",
      render: (text: string) => <p style={{ width: "max-content" }}>{text}</p>,
      sorter: (a: any, b: any) =>
        a.competencyName.localeCompare(b.competencyName),
    },
    {
      title: "Goal",
      dataIndex: "goal",
      render: (text: string) => <p style={{ width: "200px" }}>{text}</p>,
      sorter: (a: any, b: any) => a.goal.localeCompare(b.goal),
    },
    {
      title: "Category",
      dataIndex: "category",
      render: (text: string) => <p style={{ width: "100px" }}>{text}</p>,
      sorter: (a: any, b: any) => a.category.localeCompare(b.category),
    },
    {
      title: "Category Description",
      dataIndex: "categoryDescription",
      render: (text: string) => <p style={{ width: "200px" }}>{text}</p>,
      sorter: (a: any, b: any) =>
        a.categoryDescription.localeCompare(b.categoryDescription),
    },
    {
      title: "Smart Goal",
      dataIndex: "smartGoal",
      render: (text: string) => <p style={{ width: "200px" }}>{text}</p>,
      sorter: (a: any, b: any) => a.smartGoal.localeCompare(b.smartGoal),
    },
    {
      title: "Target",
      dataIndex: "target",
      render: (text: string) => <p style={{ width: "200px" }}>{text}</p>,
      sorter: (a: any, b: any) => a.target.localeCompare(b.target),
    },
    {
      title: "Target achievement Date",
      dataIndex: "targetAchievementDate",
      render: (text: string, record: any) => (
        <p className="text-inf" style={{ width: "160px" }}>
          {text}
        </p>
      ),
      sorter: (a: any, b: any) =>
        new Date(a.targetAchievementDate).getTime() -
        new Date(b.targetAchievementDate).getTime(),
    },
    {
      title: "Attachment",
      dataIndex: "attachment",
      render: (text: string, record: any, index: number) => (
        <a href={text} target="_blank" className="text-info">
          {" "}
          <i className="bi bi-file-earmark-pdf"></i> View{" "}
        </a>
      ),
      sorter: (a: any, b: any) => a.attachment.localeCompare(b.attachment),
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (text: string, record: any) => (
        <>
          <span
            className="bg-transparent d-flex"
            style={{ width: "max-content" }}
          >
            {text}
          </span>
          {/* <span className={`badge ${text === '1' ? 'badge-success' : 'badge-danger'} d-inline-flex align-items-center badge-xs`}>
                    <i className="ti ti-point-filled me-1" />
                    {text === "1" ? "Active" : "Inactive"}
                </span> */}
        </>
      ),
      // sorter: (a: any, b: any) => a.attachment.localeCompare(b.attachment),
      sorter: (a: any, b: any) => a.status.length - b.status.length,
    },
    {
      title: "Action",
      dataIndex: "actions",
      render: (_: any, record: any) => (
        <div className="action-icon d-inline-flex">
          <Link
            to="#"
            className="me-2"
            // data-bs-toggle="modal"
            // data-bs-target="#edit_empreview"
            onClick={() => {
              setSelectedItem(record);
              setLoading(true);
              setShowReviewDetail(true);
              setTimeout(() => setLoading(false), 500);
            }}
          >
            <i className="bi bi-eye"></i>
          </Link>
          <Link
            to="#"
            className="me-2"
            data-bs-toggle="modal"
            data-bs-target="#edit_empreview"
            onClick={() => {
              setSelectedItem(record);
            }}
          >
            <i className="ti ti-edit" />
          </Link>
        </div>
      ),
    },
  ];

  // const resetStates = () => {
  //     setNewItem({
  //         a: ""
  //     })
  // }

  const handleChange = <T extends Object>(
    setter: React.Dispatch<React.SetStateAction<T>>,
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    // console.log(name, value)
    setter((prev) => ({ ...prev, [name]: value }));
  };

  const handleSelect = (
    option: any,
    fieldName: string,
    setter: React.Dispatch<React.SetStateAction<any>>
  ) => {
    setter((prev: any) => ({
      ...prev,
      [fieldName]: String(option?.value),
    }));
  };

  const AddNewItem = async (e: any) => {
    e.preventDefault();
    
    try {
      // const resp = await AXIOSCONFIGMETHOD("post", webServiceUrl. , newItem)
      // // console.log(resp)
      // if (resp?.data?.success) {
      //     fetchData()
      //     resetStates()
      //     toast.success(resp?.data?.message)
      // }
    } catch (error) {
      console.error("Error while adding :", error);
    }
  };

  const UpdateItemData = async (e: any) => {
    e.preventDefault();
    try {
      // const resp = await AXIOSCONFIGMETHOD("put", webServiceUrl. , {
      // })
      // if (resp?.data?.success) {
      //     fetchData()
      //     toast.success(resp?.data?.message)
      // }
    } catch (error) {
      console.error("Error while updating :", error);
    }
  };

  const DeleteItem = async () => {
    try {
      // const resp = await AXIOSCONFIGMETHOD("delete", `${webServiceUrl?. }/${selectedItem?.ID}`)
      // if (resp?.data?.success) {
      //     fetchData()
      //     toast.success(resp?.data?.message)
      // }
    } catch (error) {
      console.error("Error while deleting :", error);
    }
  };

  const handleShowDetail = () => {
    setLoading(true);
    setShowReviewDetail(false);
    setTimeout(() => setLoading(false), 500);
  };

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Employee Reviews</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Dashboard</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    All Employee Reviews
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap gap-2">
              {!showReviewDetail && (
                <div className="mb-2">
                  <Link
                    to="#"
                    className="btn btn-primary d-flex align-items-center"
                    onClick={handleShowDetail}
                  >
                    <i className="ti ti-arrow-left me-2" />
                    Back
                  </Link>
                </div>
              )}
              <div className="input-icon w-120 position-relative mb-2">
                <select
                  value={finance_year}
                  onChange={(e) => setFinance_year(e.target.value)}
                  className="form-select"
                >
                  {(() => {
                    const today = new Date();
                    const currentYear =
                      today.getMonth() >= 3
                        ? today.getFullYear()
                        : today.getFullYear() - 1;

                    return Array.from({ length: 1 }, (_, i) => {
                      const year = currentYear - i;
                      const nextYearShort = String(year + 1).slice(-2);
                      const financialYear = `${year}-${nextYearShort}`;

                      return (
                        <option key={financialYear} value={financialYear}>
                          {financialYear}
                        </option>
                      );
                    });
                  })()}
                </select>
              </div>
            </div>
          </div>
          <div className=" mb-3 bg-white rounded-3 p-3 shadow-sm"></div>
          {/* /Breadcrumb */}
          {/* Performance Indicator list */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5>Employee Review {showReviewDetail ? "Details" : "List"}</h5>
            </div>
            <div className="card-body p-0">
              <Table
                dataSource={allItemList}
                columns={columns}
                Selection={false}
              />
            </div>
          </div>
          {/* /Performance Indicator list */}
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-center border-top bg-white p-3">
          <p className="mb-0">
            © {new Date().getFullYear()} WeConnect. All rights reserved.
          </p>
        </div>
      </div>
      {/* /Page Wrapper */}

      {/* Edit Modal */}
      <div className="modal fade" id="edit_empreview">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title text-capitalize">
                Edit Employee Review
              </h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form onSubmit={UpdateItemData}>
              <div className="modal-body pb-0">
                <div className="row">
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Category<span className="text-danger">*</span>
                      </label>
                      <CommonSelect
                        className="select"
                        options={statusChoose}
                        defaultValue={selectedItem?.category || ""}
                        onChange={(option) => {
                          handleSelect(option, "category", setSelectedItem);
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Smart Goal <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        name="smart_goal"
                        value={selectedItem?.smart_goal || ""}
                        onChange={(e) => handleChange(setSelectedItem, e)}
                        className="form-control"
                        placeholder=" Enter Smart Goal...."
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Target <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        name="target"
                        value={selectedItem?.target}
                        onChange={(e) => handleChange(setSelectedItem, e)}
                        className="form-control"
                        placeholder=" Enter Target...."
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Target Achievement Date{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="date"
                        className="form-control"
                        name="target_achievement_date"
                        value={selectedItem?.target_achievement_date || ""}
                        onChange={(e) => {
                          handleChange(setSelectedItem, e);
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Attachment <span className="text-danger">*</span>
                      </label>
                      <input
                        type="file"
                        name="Attachment"
                        // value={new}
                        className="form-control"
                        onChange={(e) => {
                          const file = e?.target?.files;
                          if (file && file.length > 0) {
                            setNewItem((prev: any) => ({
                              ...prev,
                              Attachment: file[0],
                            }));
                          }
                        }}
                      />
                      <p className=" pt-2 mb-3 muted-text">
                        Upload pdf only and size will be less than or equal to 2
                        MB
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-light me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  data-bs-dismiss="modal"
                  className="btn btn-primary"
                >
                  Save Changes
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default EmployeeBehaviouralReview;
